import { render, staticRenderFns } from "./fellowship_list.vue?vue&type=template&id=10f5da2a&scoped=true&"
import script from "./fellowship_list.vue?vue&type=script&lang=js&"
export * from "./fellowship_list.vue?vue&type=script&lang=js&"
import style0 from "./fellowship_list.vue?vue&type=style&index=0&id=10f5da2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5da2a",
  null
  
)

export default component.exports